import { CommonModule } from '@angular/common';
// Angular Imports
import { NgModule } from '@angular/core';
// This Module's Components
import { FeedbackComponent } from './feedback.component';

@NgModule({
  imports: [CommonModule],
  declarations: [FeedbackComponent],
  exports: [FeedbackComponent]
})
export class FeedbackModule {}
